import { createReducer } from '../utils/createReducer'
import { request } from '../utils/request'

const namespace = 'navigation';

const initialState = {
  navigationList: [],
};

const reducers = {
  onGetNavigationListLoad(state = initialState, action){
    return {...state, navigationList: []}
  },
  onGetNavigationListSuc(state = initialState, action){

    console.log("111")
    // document.getElementById('loader').style.opacity = 0;
    let navigationList = action.result ? action.result.sort((a, b)=> a.sort_index - b.sort_index).filter((item, index) => {

      item.Apps = item.Apps && item.Apps.filter(i => i.url.indexOf("url=&") === -1).sort((a, b)=> a.sort_index - b.sort_index);

      if (!item.Apps || item.Apps.length === 0){
        return false
      }

      return !!item.Apps
    }) : [];
    return {...state, navigationList}
  },
  onGetNavigationListErr(state = initialState, action){
    return {...state, navigationList: []}
  }
};

export default createReducer(initialState, reducers, namespace);



export function sortNavigationByGroup(action) {
  return {
    type: 'navigation/sortSuc',
    promise: request(`/category/app-sort`,{
      method: 'post',
      body: action

    }),
    action
  }
}


// WEBPACK FOOTER //
// ./src/reducers/navigation.js